// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"q4-z","colorTextValue":"r4-z","swatches":"s4-z","collapseLink":"t4-z","isCollapsed":"u4-z","dropdown":"v4-z","disabled":"w4-z"};